import React from "react";
import "./paginationselector.css";

const PaginationSelector = ({ itensPerPage, setItensPerPage }) => {
  return (
    <select
      className="cortexto"
      value={itensPerPage}
      onChange={(e) => setItensPerPage(Number(e.target.value))}
    >
      <option value={20}>20</option>
      <option value={15}>15</option>
      <option value={10}>10</option>
      <option value={5}>5</option>
    </select>
  );
};

export default PaginationSelector;
